import { UrlConstants } from "../url.constants";
export class ApiTownPlanningConstants {
    static URL = UrlConstants.API_V2 + "TownPlanning";
    static FUNCTION_SET_ZONES = "SetTownPlanningZones";
    static FUNCTION_SET_APPLICATION_TYPES = "SetTownPlanningApplicationTypes";
    static FUNCTION_GET_DISTINCT_APPLICATION_TYPES = "GetDistinctApplicationTypes";
    static FUNCTION_GET_APPLICATION_TYPE_LIMIT = "GetTpApplicationTypeLimit";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetTownPlanningApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateTownPlanningInvoiceReport";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetTownPlanningRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
    static FUNCTION_APPLICATION_TYPES = "GetTpApplicationTypes";
}
